import React, { useEffect, useState, useContext, useRef } from 'react';
import { AuthContext } from "../contexts/auth";
import CalendarMonthSelect from './calendar_month_select';
import { ChevronDownIcon, ChevronUpIcon, ChevronLeftIcon, ChevronRightIcon, DocumentPlusIcon, NoSymbolIcon, PaperClipIcon } from '@heroicons/react/24/outline';
import { LockClosedIcon, LockOpenIcon } from '@heroicons/react/20/solid';
import EditGiustificativoModal from './modal_edit_giustificativo';
import AddGiustificativoModal from './modal_add_giustificativo';
import SelectGiustificativoModal from './modal_select_giustificativo';
import ComboboxMultiSelectAPI from './combobox_multiselect_autocomplete_api';
import { getEmployeesWithActiveContract } from '../services/api_calendar';
import { getCompanyAttendance } from '../services/api_calendar';
import { getJustificationsCompanyList } from '../services/api_justifications';
import { deleteJustificationRequest } from '../services/api_justification_requests';
import { exportEmployeeAttendance } from '../services/api_extractions';
import { exportCostRefunds } from '../services/api_extractions';
import { blockMonth, getMonthBlocked } from '../services/api_months_blocked';
import Swal from 'sweetalert2';
import { Link } from 'wouter';
import Fetching from './fetching';
import moment from 'moment';
import Tooltip from '@mui/material/Tooltip';
import { styled } from '@mui/material/styles';


const Toast = Swal.mixin({
    toast: true,
    position: 'top-right',
    showConfirmButton: false,
    timer: 8000,
    timerProgressBar: true,
});

const CustomTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} />
))({
'& .MuiTooltip-tooltip': {
    backgroundColor: '#a3a3a3',
    color: '#FFFFFF',
    fontSize: '0.8rem',
},
});



const getLastDayOfCurrentMonth = () => {
    const date = new Date();
    const lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);
    const day = String(lastDay.getDate()).padStart(2, '0');
    const month = String(lastDay.getMonth() + 1).padStart(2, '0');
    const year = lastDay.getFullYear();
    return `${day}/${month}/${year}`;
};


const EmployeeAttendanceMonthTable = ({page, pageSize, setTotalResult, totalResult, setNextPage, setPrevPage, selectedUnit}) => {
    const { loading, token, profile } = useContext(AuthContext);
    const [isLoading, setIsLoading] = useState(false);
    const [isError, setIsError] = useState(false);
    const [selectedEmployees, setSelectedEmployees] = useState([]);
    const [selectedMonth, setSelectedMonth] = useState(new Date());
    const [calendarVisible, setCalendarVisible] = useState(false);
    const [isMonthOpen, setIsMonthOpen] = useState(true);
    const [showModal, setShowModal] = useState(false);
    const [selectedRequest, setSelectedRequest] = useState(null);
    const [showModalEditGiustificativo, setShowModalEditGiustificativo] = useState(false);
    const [showModalAddGiustificativo, setShowModalAddGiustificativo] = useState(false);
    const [attendanceData, setAttendanceData] = useState([]);
    const [lastDayOfCurrentMonth, setLastDayOfCurrentMonth] = useState('');
    const [selectedEmployee, setSelectedEmployee] = useState(null);
    const [selectedJustification, setSelectedJustification] = useState([]);
    const [giustificativi, setGiustificativi] = useState([]);
    const [giustificativiMap, setGiustificativiMap] = useState({});
    const [employeeBalances, setEmployeeBalances] = useState([]);
    const [selectedDay, setSelectedDay] = useState(null);
    const [selectedDescription, setSelectedDescription] = useState('');
    const [justificationRequests, setJustificationRequests] = useState([]);
    const [justificationId, setJustificationId] = useState(null);
    const [holidays, setHolidays] = useState([]);
    const tableContainerRef1 = useRef(null);
    const tableContainerRef2 = useRef(null); 
    const [isDragging, setIsDragging] = useState(false);
    const [isDayDragging, setIsDayDragging] = useState(false);
    const [startX, setStartX] = useState(0);
    const [scrollLeft1, setScrollLeft1] = useState(0);
    const [scrollLeft2, setScrollLeft2] = useState(0);
    const [selectedJustificationType, setSelectedJustificationType] = useState('');
    const [justificationsOfType, setJustificationsOfType] = useState('');
    const [showModalJustificationSelect, setShowModalJustificationSelect] = useState(false);
    const [selectedFormat, setSelectedFormat] = useState('');
    const [showDropdown, setShowDropdown] = useState(false); 
    const [dipendenti, setDipendenti] = useState([]);
    const [isDownloadError, setIsDownloadError] = useState(false);
    const controller = useRef(null);

    const isEmployee = profile.customer_type === 'employee';

    useEffect(() => {
        setLastDayOfCurrentMonth(getLastDayOfCurrentMonth());
    }, []);

    

    const handleShowMessage = () => {
        const selectedMonthValue = selectedMonth.getMonth() + 1;
        const selectedYearValue = selectedMonth.getFullYear();
        
        Swal.fire({
            title: 'Sei sicuro?',
            text: 'Bloccando il mese non potranno più essere effettuate modifiche sulle presenze. Questa operazione è irreversibile. Sei sicuro di voler confermare la chiusura?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Conferma',
            cancelButtonText: 'Annulla',
            cancelButtonColor: '#d1d5db',
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    await blockMonth(token, selectedMonthValue, selectedYearValue);
    
                    setIsMonthOpen(false);
                    
                    Swal.fire(
                        'Bloccato!',
                        'Il mese è stato bloccato.',
                        'success'
                    );
                } catch (error) {
                    console.error('Errore nel blocco del mese:', error);
                    Swal.fire(
                        'Errore!',
                        'Si è verificato un errore durante il blocco del mese.',
                        'error'
                    );
                }
            }
        });
    };
    

    const handleCloseMonth = () => {
        setIsMonthOpen(!isMonthOpen);
    };

    useEffect(() => {
        if(controller.current) {
            controller.current.abort();
            setIsLoading(false);
        }
        
        controller.current = new AbortController();

        const signal = controller.current.signal;
    
        const getData = async () => {
            if (!token) return;
            setIsLoading(true);
            setIsError(false);
    
            try {
                const startDate = formatDateMonthSelected(selectedMonth, 'start');
                const endDate = formatDateMonthSelected(selectedMonth, 'end');

                const shouldPaginate = selectedEmployees.length === 0;
    
                const attendanceResponse = await getCompanyAttendance(
                    token,
                    { startDate, endDate },
                    selectedUnit?.id,
                    selectedEmployees.map(e => e.id),
                    shouldPaginate ? page : null,
                    shouldPaginate ? pageSize : null,
                    signal
                );
    
                setNextPage(attendanceResponse.next);
                setPrevPage(attendanceResponse.previous);
                setTotalResult(attendanceResponse.count);
    
                const requiredViewPermissions = ['hr.view_attendance_ou', 'hr.view_attendance_all'];
                const canViewAttendance = profile.customer_type !== 'employee' || 
                    requiredViewPermissions.some(permission => profile.employee?.permissions?.includes(permission));
                
                if (attendanceResponse.results?.length) {
                    setDipendenti(attendanceResponse.results.map(employee => ({
                        first_name: employee.first_name,
                        last_name: employee.last_name,
                        cf: employee.cf,
                        id: employee.id,
                        email_auth: employee.email_auth,
                    })));
                } else {
                    setDipendenti([]);
                }

                if (!canViewAttendance) {
                    setAttendanceData([]);
                } else {
                    if (attendanceResponse.results && attendanceResponse.results.length > 0) {
                        setAttendanceData(attendanceResponse.results);
                    } else {
                        setAttendanceData([]);
                    }
                }
    
                const holidaysData = [];
                attendanceResponse.results?.forEach(employee => {
                    employee.days?.forEach(day => {
                        if (day.holidays && day.holidays.length > 0) {
                            day.holidays.forEach(holiday => {
                                holidaysData.push({ date: day.date, name: holiday.name });
                            });
                        }
                    });
                });
                setHolidays(holidaysData);
    
                const requiredPermissions = ['hr.manage_justification_all', 'hr.manage_justification_ou'];
                const hasJustificationPermission = profile.customer_type !== 'employee' || 
                    requiredPermissions.some(permission => profile.employee?.permissions?.includes(permission));
    
                if (!hasJustificationPermission) {
                    attendanceResponse.results?.forEach(employee => {
                        employee.days?.forEach(day => {
                            day.justifications = [];
                        });
                    });
                    setJustificationRequests([]);
                } else {
                    const giustificativiData = await getJustificationsCompanyList(token);
                    setGiustificativi(giustificativiData);
    
                    const justificationRequestsData = [];
                    const newDipendenti = [];
                    attendanceResponse.results?.forEach(employee => {
                        employee.days?.forEach(day => {
                            if (day.justifications && day.justifications.length > 0) {
                                day.justifications.forEach(justification => {
                                    justificationRequestsData.push(justification);
                                });
                            }
                        });
    
                        newDipendenti.push({
                            first_name: employee.first_name,
                            last_name: employee.last_name,
                            cf: employee.cf,
                            id: employee.id,
                            email_auth: employee.email_auth,
                        });
                    });
                    setDipendenti(newDipendenti);
                    setJustificationRequests(justificationRequestsData);
    
                    const giustificativiMapping = giustificativiData.reduce((acc, curr) => {
                        acc[curr.justification.code] = curr.justification;
                        return acc;
                    }, {});
                    setGiustificativiMap(giustificativiMapping);
                }

                // Verifica se il mese è bloccato
                const selectedMonthValue = selectedMonth.getMonth() + 1;
                const selectedYearValue = selectedMonth.getFullYear();

                const blockedMonths = await getMonthBlocked(token, { startDate, endDate });
                const isBlocked = blockedMonths.some(month =>
                    month.year === selectedYearValue && month.month === selectedMonthValue
                );

                setIsMonthOpen(!isBlocked); 
    
                setIsLoading(false);
            } catch (error) {
                if (error?.name != 'CanceledError') {
                    console.error("Errore durante il caricamento dei dati:", error);
                    setIsError(true);
                    setIsLoading(false);
                }
            }
        }
    
        getData();

    }, [token, selectedMonth, selectedEmployees, selectedUnit, page, pageSize, profile]);
    
    

    const handleExport = async (format, selectedUnit) => {
        setIsDownloadError(false);
    
        const startDate = formatDateMonthSelected(selectedMonth, 'start');
        const endDate = formatDateMonthSelected(selectedMonth, 'end');
        const businessName = profile.company.name;
    
        Toast.fire({
            icon: 'info',
            title: 'Esportazione avviata in background. Riceverai un avviso a download eseguito...',
        });
    
        try {
            await exportEmployeeAttendance(token, startDate, endDate, format, businessName, selectedUnit);
    
            Swal.fire({
                icon: 'success',
                title: 'Esportazione completata!',
                text: 'Il file delle presenze è stato scaricato con successo.',
                confirmButtonText: 'OK',
            });
    
        } catch (error) {
            setIsDownloadError(true);
            Swal.fire({
                icon: 'error',
                title: 'Errore durante l\'esportazione!',
                text: error?.message || 'Si è verificato un errore durante l\'esportazione delle presenze.',
                confirmButtonText: 'OK',
            });
        }
    };
    

    
    const handleExportCostRefunds = async () => {
        setIsLoading(true);
        setIsError(false);
    
        const month = selectedMonth.getMonth() + 1;
        const year = selectedMonth.getFullYear();
        const businessName = profile.company.name;        
    
        Swal.fire({
            title: 'Download in corso...',
            allowOutsideClick: false,
            didOpen: () => {
                Swal.showLoading();
            }
        });
    
        try {
            const result = await exportCostRefunds(token, month, year, businessName);
    
            if (!result.success) {
                Swal.fire({
                    icon: 'info',
                    title: 'Nessun dato trovato!',
                    text: result.error,
                    showConfirmButton: true,
                });
            } else {
                Swal.fire({
                    icon: 'success',
                    title: 'Esportazione completata!',
                    text: 'Il file dei rimborsi spesa è stato scaricato con successo.',
                    showConfirmButton: true,
                });
            }
        } catch (error) {
            setIsError(true);
    
            Swal.fire({
                icon: 'error',
                title: 'Errore durante l\'esportazione!',
                text: error.message,
                showConfirmButton: true,
            });
        } finally {
            setIsLoading(false);
        }
    };
    
    const formatDateMonthSelected = (date, type) => {
        const year = date.getFullYear();
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        const day =
            type === 'start'
                ? '01'
                : new Date(year, date.getMonth() + 1, 0).getDate().toString().padStart(2, '0');
        return `${year}-${month}-${day}`;
    };   

    const formatHoursFromMinutes = (minutes) => {
        const hours = minutes / 60;
        const formattedHours = hours % 1 === 0 ? hours.toFixed(0) : hours.toFixed(2);
        return formattedHours;
    };

    const handlePreviousMonth = () => {
        setSelectedMonth(new Date(selectedMonth.getFullYear(), selectedMonth.getMonth() - 1, 1));
    };

    const handleNextMonth = () => {
        setSelectedMonth(new Date(selectedMonth.getFullYear(), selectedMonth.getMonth() + 1, 1));
    };

    const handleSelectionChange = (newSelectedEmployees) => {
        setSelectedEmployees(newSelectedEmployees);
    };

    const handleDeselectEmployee = (employeeId) => {
        setSelectedEmployees((prevSelected) =>
            prevSelected.filter((emp) => emp.id !== employeeId)
        );
    };

    const handleResetSelection = () => {
        setSelectedEmployees([]);
    };

    const handleSelectClick = () => {
        setCalendarVisible(!calendarVisible);
    };

    const openModal = (selectedRequest) => {
        setSelectedRequest(selectedRequest);
        setShowModal(true);
    };

    const closeModal = () => {
        setShowModal(false);
    };
    
    const handleShowJustificationsOfType = (type, justifications, description, dipendente, dayData) => {
        setSelectedJustificationType(type);
        setSelectedDescription(description);
        setJustificationsOfType(justifications);
        setShowModalJustificationSelect(true);
        setSelectedEmployee(dipendente);
        setSelectedJustification(dayData);
    };
    

    const openModalEditGiustificativi = (justification, dipendente, dayData, justificationId) => {
        setSelectedJustification(dayData);      
        setSelectedDescription(justification);       
        setSelectedEmployee(dipendente);
        setShowModalJustificationSelect(false); 
        setShowModalEditGiustificativo(true);
        setJustificationId(justificationId);
    };
    

    // const closeModalEditGiustificativi = () => {
    //     setShowModalEditGiustificativo(false);
    // };

    const openModalAddGiustificativo = (dipendente, formattedDay, dayData) => {
        setShowModalAddGiustificativo(true);
        setSelectedEmployee(dipendente);
        setSelectedDay(formattedDay);
        setSelectedJustification(dayData);
    };
    

    // const closeModalAddGiustificativi = () => {
    //     setShowModalAddGiustificativo(false);
    // };

    const handleJustificationSelected = (description, dipendente, dayData, justificationId, status) => {      
        if (status === 'null' || status !== 'approved') {
            Swal.fire({
                html: `
                    <p style="padding-top: 10px;"><strong>Richiesta in attesa di esito.<br/> Vai alle </strong><a href="/pending_justifications" style="color: #7c3aed; text-decoration: underline;">richieste da gestire</a></p>
                `,
            });
            return;
        }
        openModalEditGiustificativi(description, dipendente, dayData, justificationId);
    };
    
    const handleUpdateJustification = async ({ dayData, justificationId, startISO, endISO, note, employee }) => {
        try {
            const updatedJustification = {
                ...dayData,
                id: justificationId,
                datetime_from: startISO,
                datetime_to: endISO,
                note,
            };
            setSelectedJustification(updatedJustification);
    
            const startDate = formatDateMonthSelected(selectedMonth, 'start');
            const endDate = formatDateMonthSelected(selectedMonth, 'end');
            getCompanyAttendance(token, { startDate, endDate }).then(attendanceResponse => 
                setAttendanceData(attendanceResponse.results)
            );   
    
        } catch (error) {
            console.error('Errore durante l\'aggiornamento del giustificativo:', error);
        }
    };
    
    const handleDeleteRequest = async (justificationId, employeeId, justificationToEdit, selectedEmployee) => {   
          const confirmDelete = await Swal.fire({
            icon: 'warning',
            title: 'Conferma eliminazione',
            text: 'Stai eliminando un giustificativo approvato. L\'azione non è reversibile. Confermi di voler eliminare?',
            showCancelButton: true,
            confirmButtonText: 'Conferma',
            cancelButtonText: 'Annulla',
            cancelButtonColor: '#d1d5db',
        });
    
        if (!confirmDelete.isConfirmed) {
            return;
        }
        
        const alertLoaderDelete = Swal.fire({
            title: 'Eliminazione in corso...',
            didOpen: () => {
                Swal.showLoading();
            },
            showConfirmButton: false,
            allowOutsideClick: false,
        });

        try {
            await deleteJustificationRequest(token, justificationId, selectedEmployee.id);   

            const updatedJustificationRequests = justificationRequests.filter(j => j && j.justification && j.justification.id !== justificationId);
            setJustificationRequests(updatedJustificationRequests);
    
            const startDate = formatDateMonthSelected(selectedMonth, 'start');
            const endDate = formatDateMonthSelected(selectedMonth, 'end');
            const attendanceResponse = await getCompanyAttendance(token, { startDate, endDate });
            if (attendanceResponse && Array.isArray(attendanceResponse.results)) {
                setAttendanceData(attendanceResponse.results);
            }
            setShowModalEditGiustificativo(false);
            alertLoaderDelete.close();
            await Swal.fire({
                icon: 'success',
                title: 'Richiesta eliminata!',
                text: 'La richiesta è stata eliminata con successo!',
                showConfirmButton: false,
                timer: 1000,
            });
        } catch (error) {
            console.error('Errore durante l\'eliminazione del giustificativo:', error);
            alertLoaderDelete.close();
            Swal.fire({
                icon: 'error',
                title: 'Errore',
                text: 'Si è verificato un errore durante l\'eliminazione del giustificativo. Per favore riprova.',
                confirmButtonText: 'OK',
            });
        }
    };

    const handleNewJustificationRequest = async (newJustificationRequest, employeeId) => {
        try {
            const updatedJustificationRequests = [...justificationRequests, newJustificationRequest];
            setJustificationRequests(updatedJustificationRequests);

            setShowModalAddGiustificativo(false);
    
            const startDate = formatDateMonthSelected(selectedMonth, 'start');
            const endDate = formatDateMonthSelected(selectedMonth, 'end');
            const attendanceResponse = await getCompanyAttendance(token, { startDate, endDate });
            setAttendanceData(attendanceResponse.results || []);
    
        } catch (error) {
            console.error('Errore durante l\'aggiunta del giustificativo:', error);
        }
    };



    const startDragging = (event) => {
        setIsDragging(true);
        setStartX(event.clientX);
        setScrollLeft1(tableContainerRef1.current.scrollLeft);
        setScrollLeft2(tableContainerRef2.current.scrollLeft);
    };
    
    const startDayDragging = (event) => {
        setIsDayDragging(true);
        setStartX(event.clientX);
        setScrollLeft1(tableContainerRef1.current.scrollLeft);
        setScrollLeft2(tableContainerRef2.current.scrollLeft);
    };
    
    const stopDragging = () => {
        setIsDragging(false);
        setIsDayDragging(false);
    };
    
    const onDragging = (event) => {
        if (!isDragging) return;
        const x = event.clientX - startX;
        tableContainerRef1.current.scrollLeft = scrollLeft1 - x;
        tableContainerRef2.current.scrollLeft = scrollLeft2 - x;
    };

    useEffect(() => {
        if (isDragging || isDayDragging) {
            document.addEventListener('mousemove', onDragging);
            document.addEventListener('mouseup', stopDragging);
        } else {
            document.removeEventListener('mousemove', onDragging);
            document.removeEventListener('mouseup', stopDragging);
        }
    
        return () => {
            document.removeEventListener('mousemove', onDragging);
            document.removeEventListener('mouseup', stopDragging);
        };
    }, [isDragging, isDayDragging]);


    const justificationColors = {
        'FE': '#fef3c7',
        'PE': '#bfdbfe',
        'RO': '#bfdbfe',
        'PD': '#bfdbfe',
        'EO': '#c4b5fd',
        'MAL': '#fecaca',
        'ST': '#fae8ff',
    };

    const getBackgroundColor = (key) => justificationColors[key] || '#f3f4f6';

    const rateoColors = {
        'BANCA ORE': '#e0e7ff',
        'PERM. EX FESTIVITÀ': '#bfdbfe',
        'FERIE': '#fef3c7',
        'PERMESSI': '#bfdbfe',
        'ROL': '#bfdbfe'
    };
    
    const getRateoBackgroundColor = (rateoName) => rateoColors[rateoName] || '#f3f4f6';


    const daysOfWeek = ['D', 'L', 'M', 'M', 'G', 'V', 'S'];
    const weekendDays = [0]; // Domenica (0)

    // if(isLoading)
    //     return (
    //         <div className='w-full'>
    //             <Fetching />
    //         </div>
    //     );
    if (isError) return <div>Error loading data</div>;

    return (
        <div className="container mx-4 px-3 rounded-md">
            <div className="grid grid-cols-1 md:grid-cols-5 mb-4 justify-center items-center">
                <div className="col-span-1 hidden md:block"></div>
                <div className="col-span-1 md:col-span-2 mb-4 items-center justify-center md:ms-5">
                    <ComboboxMultiSelectAPI
                        getData={async (query) => {
                            if (query.trim() === '') {
                            return Promise.resolve([]);
                            }

                            const page = 1;
                            const pageSize = 5;

                            try {
                            const res = await getEmployeesWithActiveContract(token, query, 'hr_active', null, page, pageSize);

                            const employeesArray = Array.isArray(res.results) ? res.results : [];
                            return employeesArray; 
                            } catch (error) {
                            console.error("Errore durante il recupero dei dati:", error);
                            return [];
                            }
                        }}
                        getDisplay={(dip) => dip.last_name && dip.first_name ? `${dip.last_name} ${dip.first_name}` : dip.cf}
                        getId={(dip) => dip.id}
                        selectedValues={selectedEmployees || selectedUnit}
                        onChange={handleSelectionChange}
                        placeholder="Cerca dipendente..."
                    />
                </div>
            </div>

            {selectedEmployees.length > 0 ? (
                <div className="mb-4">
                    <div className="flex flex-wrap gap-2 mt-2">
                        {selectedEmployees.map((employee) => (
                            <div
                                key={employee.id}
                                className="inline-flex items-center px-3 py-1 rounded-full bg-indigo-200 text-indigo-800 text-xs font-medium cursor-pointer hover:bg-indigo-300"
                                onClick={() => handleDeselectEmployee(employee.id)}
                            >
                                {employee?.last_name && employee?.first_name
                                    ? `${employee?.last_name} ${employee?.first_name}`
                                    : employee?.cf}
                                <span className="ml-2 text-gray-600 hover:text-red-500">&times;</span>
                            </div>
                        ))}
                        <button
                            className="inline-flex items-center rounded bg-indigo-600 px-2 py-1 text-xs font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                            onClick={handleResetSelection}
                        >
                            Reset selezione
                        </button>
                    </div>
                </div>
            ) : null}

            <div className="grid sm:grid-cols-1 md:grid-cols-2 w-full border-l border-r border-t border-gray-200 justify-center md:justify-between">
                {isLoading ? (
                    <div className='p-2 text-start text-sm font-semibold text-gray-600'>Caricamento...</div>
                ) : (
                    <div className="col-span-1 p-2 flex flex-col items-start text-sm uppercase text-gray-500 ml-2 me-3 mt-2">
                        <div className="flex items-center font-bold">
                            Stato mese: {isMonthOpen ? 'aperto' : 'chiuso'}
                            {isMonthOpen ? (
                                <LockOpenIcon className="w-5 h-5 ml-2 text-indigo-500" />
                            ) : (
                                <LockClosedIcon className="w-5 h-5 ml-2 text-indigo-500" />
                            )}
                        </div>
                            
                        {isMonthOpen && !isEmployee && (
                            <button
                                type="button"
                                onClick={isMonthOpen ? handleShowMessage : handleCloseMonth}
                                className="hover:bg-gray-200 text-gray-700 font-semibold border border-gray-300 shadow-md text-xs py-1.5 px-4 rounded mt-2 w-48"
                            >
                                BLOCCA MESE
                            </button>
                        )}
                    </div>
                )}

                <div className="sm:col-span-1 md:col-span-1 flex flex-col justify-end md:justify-end md:flex-row items-center mt-2 md:mt-4 md:me-4 me-0">
                    <div className="relative">
                        <div className='flex flex-col space-y-2'>
                            <button
                                type="button"
                                onClick={() => setShowDropdown(!showDropdown)}
                                disabled={isLoading}
                                className="bg-indigo-600 hover:bg-indigo-500 text-white text-xs py-1.5 px-4 rounded"
                            >
                                {isLoading ? 'Esportazione...' : 'ESPORTA PRESENZE'}
                            </button>

                            <button
                                type="button"
                                onClick={handleExportCostRefunds}
                                disabled={isLoading}
                                className="bg-indigo-600 hover:bg-indigo-500 text-white text-xs py-1.5 px-4 rounded"
                            >
                                {isLoading ? 'Esportazione...' : 'ESPORTA RIMBORSI SPESE'}
                            </button>
                        </div>

                        {showDropdown && (
                            <div
                                className="absolute mt-1 w-40 border border-gray-300 shadow-md rounded-md bg-white z-50 w-full"
                                style={{ top: '40%' }}
                            >
                                <button
                                    onClick={() => { setSelectedFormat('txt'); handleExport('txt', selectedUnit?.id); setShowDropdown(false); }}
                                    className='block w-full text-left px-4 py-2 hover:bg-indigo-100 w-full'
                                >
                                    .txt
                                </button>
                                <button
                                    onClick={() => { setSelectedFormat('excel'); handleExport('excel', selectedUnit?.id); setShowDropdown(false); }}
                                    className='block w-full text-left px-4 py-2 hover:bg-indigo-100 w-full'
                                >
                                    Excel
                                </button>
                                <button
                                    onClick={() => { setSelectedFormat('trripw'); handleExport('trripw', selectedUnit?.id); setShowDropdown(false); }}
                                    className='block w-full text-left px-4 py-2 hover:bg-indigo-100 w-full'
                                >
                                    TRRIPW (xml) <span className='text-indigo-500 text-xs font-bold'>BETA</span>
                                </button>
                            </div>
                        )}
                    </div>
                </div>
            </div>

            <div className='grid grid-cols-1 w-full'>
                <div
                    style={{ flex: '1 1 auto', width: 'auto' }}
                    className="pb-5 pt-2 px-4 border-l border-r border-gray-200 text-center w-24 text-xs font-semibold text-gray-600 uppercase align-middle"
                >
                    <div className='grid  md:grid-cols-5 sm:justify-start md:justify-around grid-cols-3'>
                        <div className='col-span-1 p-2 flex align-center justify-end sm:justify-center md:justify-end me-3'>
                            <button
                                className='text-gray-700 font-semibold px-1 hover:bg-gray-100'
                                onClick={handlePreviousMonth} 
                            >
                                <ChevronLeftIcon className="w-5 h-5 cursor-pointer" />
                            </button>
                        </div>
                        <div className='col-span-1 p-2 flex align-center md:justify-end sm:justify-center me-3'>Seleziona Mese</div>
                        <div className='col-span-1 p-2 align-center justify-start sm:justify-center md:justify-start md:hidden block'>
                            <button
                                className='text-gray-700 font-semibold px-1 hover:bg-gray-100'
                                onClick={handleNextMonth}
                            >
                                <ChevronRightIcon className='w-5 h-5 cursor-pointer' />
                            </button>
                        </div>
                        <div
                            onClick={handleSelectClick}
                            style={{ cursor: 'pointer' }}
                            className='col-span-3 md:col-span-2 border border-gray-300 rounded-md shadow-md p-2 pl-4 flex items-center md:w-4/5 w-full justify-between'
                        >
                            <div>
                                {selectedMonth.toLocaleDateString('it-IT', { month: 'long' })}, {selectedMonth.getFullYear()}
                            </div>
                            {!calendarVisible ? <ChevronDownIcon className='h-4 w-4 bg-indigo-100 rounded-md' /> : <ChevronUpIcon className='h-4 w-4 bg-indigo-100 rounded-md' />}
                        </div>
                        <div className='col-span-1 p-2 align-start justify-start hidden md:block'>
                            <button
                                className='text-gray-700 font-semibold px-1 hover:bg-gray-100 flex items-start'
                                onClick={handleNextMonth}
                            >
                                <ChevronRightIcon className='w-5 h-5 cursor-pointer' />
                            </button>
                        </div>
                    </div>
                    {calendarVisible &&         
                        <CalendarMonthSelect
                            selectedMonth={selectedMonth}
                            onMonthSelect={setSelectedMonth}
                            onCloseCalendar={handleSelectClick}
                        />
                    }
                </div>      
            </div>
            <div>
                <h2 className='p-2 text-start text-xs border-x font-semibold text-gray-600'>* Seleziona con il mouse tenendo premuto un qualsiasi punto della tabella e trascina a destra o sinistra per scorrere i giorni</h2>
            </div>
                    
  
            {isLoading ? (
                <Fetching />
            ) : (
                <>
                    <div style={{ overflow: 'auto',  }}>
                        <div
                            ref={tableContainerRef1}
                            style={{ overflowX: 'hidden', cursor: isDragging ? 'grabbing' : 'grab' }}
                            onMouseDown={startDragging}
                            onMouseUp={stopDragging}
                            onMouseMove={onDragging}
                        >
                        <table className="min-w-full border border-gray-200 divide-y divide-gray-200">
                            <thead 
                                style={{
                                    position: 'sticky',
                                    top: 0,
                                    background: 'white',
                                    zIndex: 3,
                                    border: '2px solid #e5e7eb',
                                    minWidth: '7rem',
                                    overflow: 'auto',
                                    cursor: isDragging || isDayDragging ? 'grabbing' : 'grab',
                                    maxWidth: '100%'
                                }}
                                onMouseDown={startDragging}
                            >
                                <tr>
                                    <th
                                        style={{
                                            position: 'sticky',
                                            left: 0,
                                            background: 'white',
                                            zIndex: 1,
                                            border: '2px solid #e5e7eb',
                                            minWidth: '10rem',
                                            maxWidth: '10rem',
                                        }}
                                        className="px-2 py-3 border-2 border-gray-200 text-left text-xs bg-white font-semibold text-gray-600 uppercase w-28"
                                    >
                                        Dipendenti
                                    </th>
                                    {Array.from({ length: new Date(selectedMonth.getFullYear(), selectedMonth.getMonth() + 1, 0).getDate() }).map((_, index) => {
                                        const dayNumber = index + 1;
                                        const dayOfWeek = new Date(selectedMonth.getFullYear(), selectedMonth.getMonth(), dayNumber).getDay();

                                        const dayOfWeekInitial = daysOfWeek[dayOfWeek];
                                        const isWeekend = weekendDays.includes(dayOfWeek);

                                        const formattedDate = `${selectedMonth.getFullYear()}-${(selectedMonth.getMonth() + 1).toString().padStart(2, '0')}-${dayNumber.toString().padStart(2, '0')}`;
                                        const holidayInfos = holidays.filter(holiday => holiday.date === formattedDate);
                                        const holidayNamesSet = new Set(holidayInfos.map(holiday => holiday.name));
                                        const holidayNames = Array.from(holidayNamesSet).join(', ');
                                        
                                        const textColorClass = holidayInfos.length > 0 ? 'text-orange-400 font-bold text-sm' : (isWeekend ? 'text-emerald-500 font-bold text-sm' : 'text-gray-600 text-xs');

                                        const handleInfoHoliday = () => {
                                            if (holidayInfos.length > 0) {
                                                Swal.fire({
                                                    title: 'Festività',
                                                    html: `<p>${holidayNames}</p>`,
                                                    confirmButtonText: 'OK',
                                                });
                                            }
                                        };

                                        return (
                                            <th
                                                key={index}
                                                className={`py-1 px-4 border-2 border-gray-200 text-center w-24 font-semibold uppercase ${textColorClass}`}
                                                style={{
                                                    minWidth: '3rem',
                                                    maxWidth: '3rem',
                                                    cursor: holidayInfos.length > 0 ? 'pointer' : isDayDragging ? 'grabbing' : 'grab',
                                                }}
                                                onClick={handleInfoHoliday}
                                                onMouseDown={startDayDragging}
                                            >
                                                <div>
                                                    {dayNumber}
                                                    <div className={`pt-2 ${textColorClass}`}>{dayOfWeekInitial}</div>
                                                </div>
                                            </th>
                                        );
                                    })}
                                    <th
                                        style={{
                                            position: 'sticky',
                                            right: '8.8rem',
                                            background: 'white',
                                            zIndex: 2,
                                            borderLeft: '2px solid #e5e7eb',
                                            minWidth: '9rem',
                                            maxWidth: '9rem',
                                        }}
                                        className="pr-4 py-3 px-2 border-2 border-gray-200 text-center border-l text-xs w-full bg-white font-semibold text-gray-600 uppercase"
                                    >
                                        Totali Ore mese
                                    </th>
                                    <th
                                        style={{
                                            position: 'sticky',
                                            right: 0,
                                            background: 'white',
                                            zIndex: 2,
                                            borderLeft: '2px solid #e5e7eb',
                                            minWidth: '9rem',
                                            maxWidth: '9rem',
                                        }}
                                        className="pr-4 py-3 px-2 border-2 border-gray-200 text-center border-l text-xs w-28 font-semibold text-gray-600 uppercase"
                                    >
                                        Residuo ratei al <br /> {lastDayOfCurrentMonth}
                                    </th>
                                </tr>
                            </thead>
                        </table>
                        </div>
                    </div>
                
                    <div style={{ overflow: 'auto', maxHeight: '70vh' }}>
                        <div
                            ref={tableContainerRef2}
                            style={{  overflowX: 'hidden', cursor: isDragging ? 'grabbing' : 'grab' }}
                            onMouseDown={startDragging}
                            onMouseUp={stopDragging}
                            onMouseMove={onDragging}
                        >
                            <table className="min-w-full border-collapse border divide-y divide-gray-200">
                                {/* <thead 
                                    style={{
                                        position: 'sticky',
                                        top: 0,
                                        background: 'white',
                                        zIndex: 3,
                                        border: '2px solid #e5e7eb',
                                        minWidth: '7rem',
                                        display: isScrolled ? 'none' : 'table-header-group',
                                    }}
                                >
                                    <tr>
                                        <th
                                            style={{
                                                position: 'sticky',
                                                left: 0,
                                                top: 0,
                                                background: 'white',
                                                zIndex: 2,
                                                border: '2px solid #e5e7eb',
                                                minWidth: '7rem',
                                            }}
                                            className="pl-4 py-3 border-2 border-gray-200 text-left text-xs w-28 font-semibold text-gray-600 uppercase"
                                        >
                                            Dipendenti
                                        </th>
                                        {Array.from({ length: new Date(selectedMonth.getFullYear(), selectedMonth.getMonth() + 1, 0).getDate() }).map((_, index) => {
                                            const dayNumber = index + 1;
                                            const dayOfWeek = new Date(selectedMonth.getFullYear(), selectedMonth.getMonth(), dayNumber).getDay();

                                            const dayOfWeekInitial = daysOfWeek[dayOfWeek];
                                            const isWeekend = weekendDays.includes(dayOfWeek);

                                            const formattedDate = `${selectedMonth.getFullYear()}-${(selectedMonth.getMonth() + 1).toString().padStart(2, '0')}-${dayNumber.toString().padStart(2, '0')}`;
                                            const holidayInfos = holidays.filter(holiday => holiday.date === formattedDate);
                                            const holidayNamesSet = new Set(holidayInfos.map(holiday => holiday.name));
                                            const holidayNames = Array.from(holidayNamesSet).join(', ');
                                            
                                            const textColorClass = holidayInfos.length > 0 ? 'text-orange-400 font-bold text-sm' : (isWeekend ? 'text-emerald-500 font-bold text-sm' : 'text-gray-600 text-xs');

                                            const handleInfoHoliday = () => {
                                                if (holidayInfos.length > 0) {
                                                    Swal.fire({
                                                        title: 'Festività',
                                                        html: `<p>${holidayNames}</p>`,
                                                        confirmButtonText: 'OK',
                                                    });
                                                }
                                            };

                                            return (
                                                <th
                                                    key={index}
                                                    className={`py-1 px-4 border-2 border-gray-200 text-center w-24 font-semibold uppercase ${textColorClass}`}
                                                    style={{
                                                        minWidth: '3rem',
                                                        maxWidth: '3rem',
                                                        cursor: holidayInfos.length > 0 ? 'pointer' : isDayDragging ? 'grabbing' : 'grab',
                                                    }}
                                                    onClick={handleInfoHoliday}
                                                    onMouseDown={startDayDragging}
                                                >
                                                    <div>
                                                        {dayNumber}
                                                        <div className={`pt-2 ${textColorClass}`}>{dayOfWeekInitial}</div>
                                                    </div>
                                                </th>
                                            );
                                        })}
                                        <th
                                            style={{
                                                position: 'sticky',
                                                right: '8.8rem',
                                                background: 'white',
                                                zIndex: 2,
                                                borderLeft: '2px solid #e5e7eb',
                                                minWidth: '9rem',
                                                maxWidth: '9rem',
                                            }}
                                            className="pr-4 py-3 px-2 border-2 border-gray-200 text-center border-l text-xs w-full bg-white font-semibold text-gray-600 uppercase"
                                        >
                                            Totali Ore mese
                                        </th>
                                        <th
                                            style={{
                                                position: 'sticky',
                                                right: 0,
                                                background: 'white',
                                                zIndex: 2,
                                                borderLeft: '2px solid #e5e7eb',
                                                minWidth: '9rem',
                                                maxWidth: '9rem',
                                            }}
                                            className="pr-4 py-3 px-2 border-2 border-gray-200 text-center border-l text-xs w-28 font-semibold text-gray-600 uppercase"
                                        >
                                            Residuo ratei al <br /> {lastDayOfCurrentMonth}
                                        </th>
                                    </tr>
                                </thead> */}
                                
                                <tbody className="bg-white divide-y divide-gray-200">
                                    {(() => {
                                        const employeesToShow = selectedEmployees.length > 0 ? selectedEmployees : dipendenti;
                                        
                                        if (!isLoading && employeesToShow.length === 0) {
                                            return (
                                                <tr>
                                                    <td colSpan={33} className="pl-4 py-3 border-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-600 uppercase">
                                                        Non sono presenti anagrafiche
                                                    </td>
                                                </tr>
                                            );
                                        }

                                        const daysInMonth = Array.from({ length: new Date(selectedMonth.getFullYear(), selectedMonth.getMonth() + 1, 0).getDate() });
                                        const justificationTypes = Array.from(new Set(
                                            Array.isArray(attendanceData)
                                                ? attendanceData.flatMap(employee => 
                                                    employee.days.flatMap(day => 
                                                        day.justifications.map(justification => justification.code)
                                                    )
                                                )
                                                : [] 
                                        )).sort();
                                        
                                        const justificationMap = justificationTypes.reduce((acc, type, index) => {
                                            acc[type] = index;
                                            return acc;
                                        }, {});

                                        const attendanceDataByCf = (Array.isArray(attendanceData)
                                        ? attendanceData.reduce((acc, curr) => {
                                            acc[curr.id] = curr;
                                            return acc;
                                        }, {})
                                        : {});
                                        

                                        return employeesToShow
                                            .slice()
                                            .sort((a, b) => {
                                                const aValue = a.last_name || a.cf;
                                                const bValue = b.last_name || b.cf;
                                                return aValue.localeCompare(bValue);    
                                            })
                                            .map((dipendente, rowIndex) => {

                                                const employeeAttendance = attendanceDataByCf[dipendente.id];

                                                return (
                                                    <tr key={rowIndex}>
                                                        <td
                                                            style={{
                                                                position: 'sticky',
                                                                left: 0,
                                                                background: 'white',
                                                                zIndex: 1,
                                                                border: '2px solid #e5e7eb',
                                                                minWidth: '10rem',
                                                                maxWidth: '10rem'
                                                            }}
                                                            className="px-2 py-3 border-2 border-gray-200 text-left text-xs bg-white font-semibold text-gray-600 uppercase w-28"
                                                            title={dipendente.first_name ? `${dipendente.last_name} ${dipendente.first_name}` : dipendente.cf}
                                                        >
                                                            <Link to={`/dipendenti/${dipendente.cf}`} className="hover:text-indigo-600">
                                                                {dipendente.first_name ? `${dipendente.last_name} ${dipendente.first_name}`.slice(0, 25) : dipendente.cf}
                                                                {dipendente.first_name && `${dipendente.last_name} ${dipendente.first_name}`.length > 25 ? '...' : ''}
                                                            </Link>
                                                        </td>
                                                        {daysInMonth.map((_, i) => {
                                                            
                                                            const dayData = employeeAttendance ? employeeAttendance.days[i] : null;

                                                            const weekHours = dayData ? dayData.week_hours : null;
                                                            const shiftType = dayData ? dayData.shift_type : null;

                                                            let canAddJustification = (
                                                                shiftType === 'a_chiamata'
                                                                || (shiftType === 'turno' && weekHours && weekHours > 0)
                                                                || (shiftType === 'fisso' && weekHours && weekHours > 0)
                                                            );

                                                            const hasActiveContract = dayData?.has_active_contract;
                                                            let hours = '-';
                                                            let justifications = [];

                                                            if (dayData && dayData.shift_type !== null && (dayData.week_hours || dayData.shift_type === 'a_chiamata')) {
                                                                let attendanceHours = dayData.attendance_expected / 60;
                                                                const formattedHours = Number.isInteger(attendanceHours) ? attendanceHours.toFixed(0) : attendanceHours.toFixed(2);
                                                                hours = formattedHours;

                                                                justifications = dayData.justifications;
                                                            }

                                                            const year = selectedMonth.getFullYear();
                                                            const month = selectedMonth.getMonth() + 1;
                                                            const dayOfMonth = i + 1;

                                                            const formattedDay = `${year}-${month < 10 ? '0' + month : month}-${dayOfMonth < 10 ? '0' + dayOfMonth : dayOfMonth}`;
                                                            const isWeekend = weekendDays.includes(new Date(year, month - 1, dayOfMonth).getDay());
                                                            const isHoliday = holidays.find(holiday => holiday.date === formattedDay);
                                                            const isHolidayWeekend = isHoliday && isWeekend;

                                                            const hasJustifications = justifications.length > 0;

                                                            const showNoWeekHoursPattern = (!weekHours && shiftType && shiftType !== 'senza_calendario' && shiftType !== 'a_chiamata');

                                                            return (
                                                                <td
                                                                    key={i}
                                                                    className={`border-2 border-gray-200 text-center text-sm font-semibold uppercase p-0 `}
                                                                    style={{
                                                                        minWidth: '3rem',
                                                                        maxWidth: '3rem',
                                                                        position: 'relative',
                                                                        padding: 0,
                                                                        verticalAlign: 'top',
                                                                        paddingBottom: '2.5rem',
                                                                        ...((isHoliday && weekHours && shiftType !== 'senza_calendario') ? SvgHoliday() : {}),
                                                                        ...((isHolidayWeekend && weekHours && shiftType !== 'senza_calendario') ? SvgHolidayWeekend() : {}),
                                                                        ...((isWeekend && !isHoliday && weekHours && shiftType !== 'senza_calendario') ? SvgPattern() : {}),
                                                                        ...((shiftType === 'senza_calendario') && PatternNoCalendar()),
                                                                        ...(showNoWeekHoursPattern && PatternNoWeekHours()),
                                                                    }}
                                                                    onClick={() => {
                                                                        // if (!isMonthOpen) {
                                                                        //     Swal.fire({
                                                                        //         title: 'Mese bloccato',
                                                                        //         text: 'Il mese è bloccato. Modifiche non consentite.',
                                                                        //         icon: 'error',
                                                                        //         confirmButtonText: 'Ok',
                                                                        //     });
                                                                        //     return;
                                                                        // }
                                                                        if (shiftType === 'senza_calendario') {
                                                                            Swal.fire({
                                                                                title: 'Tipologia contratto senza calendario',
                                                                                html: `La tipologia contratto è 'Senza calendario' e non è possibile gestire i giustificativi.<br /> Vai sulla <a href="/dipendenti/${dipendente.cf}/edit?tab=2" style="color: #4338ca; text-decoration: underline;">MODIFICA CONTRATTO</a> per aggiornare.`,
                                                                                icon: 'warning',
                                                                                confirmButtonText: 'Ok',
                                                                            });
                                                                        } else if (hasActiveContract && !weekHours && shiftType !== 'a_chiamata') {
                                                                            Swal.fire({
                                                                                title: 'Orario settimanale mancante',
                                                                                html: `Il dipendente non ha orario lavorativo settimanale.<br /> Vai su <a href="/dipendenti/${dipendente.cf}/edit?tab=2" style="color: #4338ca; text-decoration: underline;">MODIFICA CONTRATTO</a> per salvare l'orario.`,
                                                                                icon: 'info',
                                                                                confirmButtonText: 'Ok',
                                                                            });
                                                                        }
                                                                    }}
                                                                >
                                                                    <div
                                                                        className="align-top"
                                                                        style={{
                                                                            position: 'absolute',
                                                                            top: '5px',
                                                                            width: '100%',
                                                                            display: hours !== '0' ? 'flex' : 'none',
                                                                            justifyContent: 'center',
                                                                            backgroundColor: !['0', '-'].includes(hours)  ? '#d1fae5' : 'transparent',
                                                                            ...(!hasActiveContract && PatternInactiveEmployee()),
                                                                        }}
                                                                        >
                                                                        <span className="px-1">{hours === '-' ? <span className='text-transparent'>-</span> : hours }</span>
                                                                    </div>

                                                                    {hasJustifications && (
                                                                        <div className='flex flex-col justify-stretch mb-5' style={{ position: 'relative', top: '2rem', paddingBottom: '1.5rem' }}>
                                                                            <div className='relative flex flex-col align-top h-full'>
                                                                                {justificationTypes.map((type, index) => {
                                                                                    const justificationsOfType = justifications.filter(j => j.code === type);
                                                                                    const hasOuPair = justificationsOfType.some(j => j.ou);

                                                                                    if (justificationsOfType.length > 0) {
                                                                                        const totalHours = justificationsOfType.reduce((sum, j) => sum + j.duration, 0) / 60;
                                                                                        let formattedTotalHours = Number.isInteger(totalHours) ? totalHours.toFixed(0) : totalHours.toFixed(2);
                                                                                        if (formattedTotalHours.endsWith('.00')) {
                                                                                            formattedTotalHours = totalHours.toFixed(0);
                                                                                        }

                                                                                        const backgroundColor = justificationsOfType.some(j => j.status === 'approved') ? getBackgroundColor(type) : '';

                                                                                        const handleClick = () => {
                                                                                            if (justificationsOfType.length === 1) {
                                                                                                const justification = justificationsOfType[0];
                                                                                                handleJustificationSelected(
                                                                                                    justification.description || justification.code, 
                                                                                                    dipendente, 
                                                                                                    dayData, 
                                                                                                    justification.id, 
                                                                                                    justification.status
                                                                                                );
                                                                                            } else {
                                                                                                const description = justificationsOfType[0]?.description || '';
                                                                                                handleShowJustificationsOfType(
                                                                                                    type, 
                                                                                                    justificationsOfType, 
                                                                                                    description,
                                                                                                    dipendente, 
                                                                                                    dayData
                                                                                                );
                                                                                            }
                                                                                        };

                                                                                        return (
                                                                                            <CustomTooltip key={`${type}-${index}`} title={hasOuPair && justificationsOfType[0]?.ou_name} placement="top-start">
                                                                                                <span
                                                                                                    className={`my-0.5 cursor-pointer relative w-full text-gray-700 flex items-center justify-center pt-0.5 ${formattedTotalHours === '0' && 'bg-white border border-y border-gray-200 shadow-md'}`}
                                                                                                    style={{
                                                                                                        backgroundColor: backgroundColor || 'white',
                                                                                                        position: 'absolute',
                                                                                                        top: `${justificationMap[type] * 25}px`,
                                                                                                        left: '50%',
                                                                                                        transform: 'translateX(-50%)',
                                                                                                    }}
                                                                                                    onClick={handleClick}
                                                                                                >
                                                                                                    {formattedTotalHours !== '0' ? formattedTotalHours : '-'}
                                                                                                    {hasOuPair && (
                                                                                                        <div 
                                                                                                            className="absolute top-0 right-0"
                                                                                                            style={{
                                                                                                                width: 0,
                                                                                                                height: 0,
                                                                                                                borderLeft: '10px solid transparent',
                                                                                                                borderTop: '10px solid gray',
                                                                                                            }}
                                                                                                        />
                                                                                                    )}
                                                                                                </span>
                                                                                            </CustomTooltip>
                                                                                        );
                                                                                    } else {
                                                                                        return <span key={`empty-${index}`} className="my-0.5 text-gray-400">&nbsp;</span>;
                                                                                    }
                                                                                })}
                                                                            </div>
                                                                        </div>
                                                                    )}

                                                                    {canAddJustification && (
                                                                        <div key={i}>
                                                                            <div
                                                                                className="bottom-0 cursor-pointer border-t bg-white"
                                                                                style={{
                                                                                    position: 'absolute',
                                                                                    bottom: '0',
                                                                                    width: '100%',
                                                                                    textAlign: 'center',
                                                                                    display: 'flex',
                                                                                    justifyContent: 'center',
                                                                                    alignItems: 'center'
                                                                                }}
                                                                                title='Aggiungi giustificativo'
                                                                            >
                                                                                {dayData && isMonthOpen && (
                                                                                    <DocumentPlusIcon
                                                                                        className="w-full h-4 m-1 bg-white text-gray-400 hover:bg-indigo-50 hover:text-indigo-500"
                                                                                        onClick={(e) => {
                                                                                            e.stopPropagation();
                                                                                            const requiredPermissions = ['hr.manage_justification_all', 'hr.manage_justification_ou'];
                                                                                            const hasPermission = profile.customer_type !== 'employee' || 
                                                                                                requiredPermissions.some(permission => profile.employee.permissions.includes(permission));
                                                                                            
                                                                                            if (!hasPermission) {
                                                                                                Swal.fire({
                                                                                                    icon: 'warning',
                                                                                                    title: 'Non hai i permessi per eseguire questa azione',
                                                                                                    showConfirmButton: true,
                                                                                                    confirmButtonText: 'OK',
                                                                                                });
                                                                                            } else {
                                                                                                openModalAddGiustificativo(dipendente, formattedDay, dayData);
                                                                                            }
                                                                                        }}
                                                                                    />
                                                                                )}
                                                                            </div>
                                                                        </div>
                                                                    )}
                                                                </td>
                                                            );
                                                        })}

                                                        {/* COLONNA TOTALI */}
                                                        <td
                                                            style={{
                                                                position: 'sticky',
                                                                right: '8.8rem',
                                                                background: 'white',
                                                                zIndex: 1,
                                                                border: '2px solid #e5e7eb',
                                                                minWidth: '9rem',
                                                                maxWidth: '9rem',
                                                                verticalAlign: 'top'
                                                            }}
                                                            className="px-1 text-start text-xs font-semibold bg-gray-50 text-gray-600"
                                                        >
                                                            <div className='px-1 shadow-md flex flex-col justify-start py-1'>
                                                                <div className='flex justify-between text-xs'>
                                                                    PRESENZA
                                                                </div>
                                                                <div className='flex justify-between text-xs'>
                                                                    <span className='pl-3'>Prevista</span>
                                                                    <span className='ml-1 bg-emerald-100 text-gray-900 cursor-help'>
                                                                        {employeeAttendance && (() => {
                                                                            let totalPresenceHours = 0;
                                                                            employeeAttendance.days.forEach((day) => {
                                                                                if (day.attendance_expected) {
                                                                                    totalPresenceHours += day.attendance_expected / 60;
                                                                                }
                                                                            });
                                                                            const formattedTotal = totalPresenceHours % 1 === 0 ? totalPresenceHours.toFixed(0) : totalPresenceHours.toFixed(2);
                                                                            return formattedTotal;
                                                                        })()}
                                                                    </span>
                                                                </div>
                                                                <div className='flex justify-between text-xs'>
                                                                    <span className='pl-3'>Effettiva</span>
                                                                    <span className='ml-1 bg-emerald-100 text-gray-900'>
                                                                        {employeeAttendance && (() => {
                                                                            let totalPresenceHours = 0;
                                                                            employeeAttendance.days.forEach((day) => {
                                                                                if (day.attendance_actual) {
                                                                                    totalPresenceHours += day.attendance_actual / 60;
                                                                                }
                                                                            });
                                                                            const formattedTotal = totalPresenceHours % 1 === 0 ? totalPresenceHours.toFixed(0) : totalPresenceHours.toFixed(2);
                                                                            return formattedTotal;
                                                                        })()}
                                                                    </span>
                                                                </div>
                                                                {employeeAttendance && (() => {
                                                                    const totalJustifications = {};
                                                                    employeeAttendance.days.forEach((day) => {
                                                                        if (day.justifications) {
                                                                            day.justifications.forEach((justification) => {
                                                                                if (justification.status === 'approved') {
                                                                                    totalJustifications[justification.code] = (totalJustifications[justification.code] || 0) + justification.duration;
                                                                                }
                                                                            });
                                                                        }
                                                                    });

                                                                    return justificationTypes.map((type, index) => {
                                                                        if (totalJustifications[type]) {
                                                                            const justificationHours = totalJustifications[type] / 60;
                                                                            const backgroundColor = getBackgroundColor(type);
                                                                
                                                                            let formattedJustificationHours = Number.isInteger(justificationHours) ? justificationHours.toFixed(0) : justificationHours.toFixed(2);
                                                                            if (formattedJustificationHours.endsWith('.00')) {
                                                                                formattedJustificationHours = justificationHours.toFixed(0);
                                                                            }
                                                                            const justificationDetails = giustificativiMap[type] || {};
                                                                            let fullDescription = justificationDetails.description || type;
                                                                            let description = justificationDetails.description || type;
                                                                            if (description.length > 10) {
                                                                                description = description.substring(0, 10) + '.';
                                                                            }
                                                                
                                                                            return (
                                                                                <div key={index} className={`flex justify-between items-center border-gray-200 cursor-help text-gray-900`} title={fullDescription}>
                                                                                    {description}
                                                                                    <span 
                                                                                        className='py-0.5'
                                                                                        style={{ backgroundColor: backgroundColor || 'white' }}
                                                                                    >
                                                                                        {formattedJustificationHours !== '0' ? formattedJustificationHours : '-'}
                                                                                    </span>
                                                                                </div>
                                                                            );
                                                                        } else {
                                                                            return null;
                                                                        }
                                                                    });                    
                                                                })()}
                                                            </div>
                                                        </td>

                                                        {/* COLONNA RESIDUI */}
                                                        <td
                                                            style={{
                                                                position: 'sticky',
                                                                right: 0,
                                                                background: 'white',
                                                                zIndex: 1,
                                                                borderLeft: '2px solid #e5e7eb',
                                                                minWidth: '9rem',
                                                                maxWidth: '9rem',
                                                                verticalAlign: 'top',
                                                                height: '100%',
                                                            }}
                                                            className="px-1 text-start text-xs font-semibold bg-gray-50 text-gray-600 pt-3 h-full"
                                                        >
                                                            <div
                                                                className={`px-1 flex flex-col justify-start py-1 ${employeeAttendance?.balances?.length > 0 ? 'shadow-md' : ''}`}
                                                                style={{ display: employeeAttendance?.balances.length > 0 ? 'block' : 'none' }}
                                                            >
                                                                <div className='text-transparent h-2'>Residui</div>
                                                                {employeeAttendance && (
                                                                    <div className="flex flex-col justify-start py-1">
                                                                        {employeeAttendance.balances.map((balanceItem, balanceIndex) => (
                                                                            <div key={balanceIndex} className="flex justify-between text-gray-900 cursor-pointer hover:underline">
                                                                                <Link
                                                                                    to={`/dipendenti/${dipendente.cf}?tab=residui`}
                                                                                    className="hover:text-indigo-600 uppercase"
                                                                                >
                                                                                    <span>
                                                                                        {balanceItem.rateo.name}
                                                                                    </span>
                                                                                </Link>
                                                                                
                                                                                {/* <span className='uppercase'>
                                                                                    {balanceItem.rateo.name.length > 8 ? `${balanceItem.rateo.name.substring(0, 8) + '.'}` : balanceItem.rateo.name}
                                                                                </span> */}
                                                                                <Link
                                                                                    to={`/dipendenti/${dipendente.cf}/`}
                                                                                    className="hover:text-indigo-600 uppercase"
                                                                                >
                                                                                    <span style={{ backgroundColor: getRateoBackgroundColor(balanceItem.rateo.name) }}>
                                                                                        {formatHoursFromMinutes(balanceItem.value)}
                                                                                    </span>
                                                                                </Link>
                                                                            </div>
                                                                        ))}
                                                                    </div>
                                                                )}
                                                            </div>
                                                        </td>
                                                    </tr>
                                                );
                                            });
                                        })
                                    ()}
                                </tbody>
                            </table>
                        </div>    
                    </div>
                </>
            )}

            {showModalEditGiustificativo && (
                <EditGiustificativoModal
                    selectedJustification={selectedJustification}
                    selectedDescription={selectedDescription}
                    selectedEmployee={selectedEmployee}
                    justificationId={justificationId}
                    closeModalEditGiustificativi={() => setShowModalEditGiustificativo(false)}
                    updateJustification={handleUpdateJustification}
                    onDeleteRequest={handleDeleteRequest}
                />
            )}

            {showModalAddGiustificativo && (
                <AddGiustificativoModal
                    closeModalAddGiustificativi={() => setShowModalAddGiustificativo(false)}
                    dipendente={selectedEmployee}
                    formattedDay={selectedDay}
                    selectedJustification={selectedJustification}
                    onSaveJustificationRequest={handleNewJustificationRequest}
                    selectedUnit={selectedUnit}
                />
            )}


            {showModalJustificationSelect && selectedEmployee && (
                <SelectGiustificativoModal
                    selectedJustification={selectedJustification}
                    selectedDescription={selectedDescription}
                    selectedEmployee={selectedEmployee}
                    selectedJustificationType={selectedJustificationType}
                    justificationsOfType={justificationsOfType}
                    onJustificationSelected={handleJustificationSelected}
                    onClose={() => setShowModalJustificationSelect(false)} 
                />
            )}
        </div>
    );
};

export default EmployeeAttendanceMonthTable;

const SvgPattern = () => {
    return {
        backgroundColor: '#ffffff',
        backgroundImage: `url("data:image/svg+xml,%3Csvg width='48' height='32' viewBox='0 0 48 32' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%2322c55e' fill-opacity='0.13'%3E%3Cpath d='M27 32c0-3.314 2.686-6 6-6 5.523 0 10-4.477 10-10S38.523 6 33 6c-3.314 0-6-2.686-6-6h2c0 2.21 1.79 4 4 4 6.627 0 12 5.373 12 12s-5.373 12-12 12c-2.21 0-4 1.79-4 4h-2zm-6 0c0-3.314-2.686-6-6-6-5.523 0-10-4.477-10-10S9.477 6 15 6c3.314 0 6-2.686 6-6h-2c0 2.21-1.79 4-4 4C8.373 4 3 9.373 3 16s5.373 12 12 12c2.21 0 4 1.79 4 4h2z' /%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
        backgroundRepeat: 'repeat',
    };
};

const SvgHoliday = () => {
    return {
        backgroundColor: '#ffffff',
        backgroundImage: `url("data:image/svg+xml,%3Csvg width='48' height='32' viewBox='0 0 48 32' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23fed7aa' fill-opacity='0.4'%3E%3Cpath d='M27 32c0-3.314 2.686-6 6-6 5.523 0 10-4.477 10-10S38.523 6 33 6c-3.314 0-6-2.686-6-6h2c0 2.21 1.79 4 4 4 6.627 0 12 5.373 12 12s-5.373 12-12 12c-2.21 0-4 1.79-4 4h-2zm-6 0c0-3.314-2.686-6-6-6-5.523 0-10-4.477-10-10S9.477 6 15 6c3.314 0 6-2.686 6-6h-2c0 2.21-1.79 4-4 4C8.373 4 3 9.373 3 16s5.373 12 12 12c2.21 0 4 1.79 4 4h2z' /%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
        backgroundRepeat: 'repeat',
    };
};


const SvgHolidayWeekend = () => {
    return {
        backgroundColor: '#feead2',
        backgroundImage: `url("data:image/svg+xml,%3Csvg width='48' height='32' viewBox='0 0 48 32' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='1'%3E%3Cpath d='M27 32c0-3.314 2.686-6 6-6 5.523 0 10-4.477 10-10S38.523 6 33 6c-3.314 0-6-2.686-6-6h2c0 2.21 1.79 4 4 4 6.627 0 12 5.373 12 12s-5.373 12-12 12c-2.21 0-4 1.79-4 4h-2zm-6 0c0-3.314-2.686-6-6-6-5.523 0-10-4.477-10-10S9.477 6 15 6c3.314 0 6-2.686 6-6h-2c0 2.21-1.79 4-4 4C8.373 4 3 9.373 3 16s5.373 12 12 12c2.21 0 4 1.79 4 4h2z' /%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
        backgroundRepeat: 'repeat',
    };
};


const PatternInactiveEmployee = () => {
    return {
        backgroundColor: '#ffffff',
        backgroundImage: `url("data:image/svg+xml,%3Csvg width='6' height='6' viewBox='0 0 6 6' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='%234f46e5' fill-opacity='1' fill-rule='evenodd'%3E%3Cpath d='M5 0h1L0 6V5zM6 5v1H5z'/%3E%3C/g%3E%3C/svg%3E")`,
        backgroundRepeat: 'repeat',
    };
};

const PatternNoWeekHours = () => {
    return {
        backgroundColor: '#fffbeb',
        cursor: 'pointer',
    };
};

const PatternNoCalendar = () => {
    return {
        backgroundColor: '#f1f5f9',
        cursor: 'pointer',
    };
};